module.exports = __webpack_public_path__ + "img/83.1da04c94.jpg";